import { render, staticRenderFns } from "./catch_basin.vue?vue&type=template&id=63672db4&"
import script from "./catch_basin.vue?vue&type=script&lang=js&"
export * from "./catch_basin.vue?vue&type=script&lang=js&"
import style0 from "./catch_basin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports